<template>
  <div class="demand_box">
    <div class="owner_title">修改金主信息</div>
    <div class="owner_box">
      <el-form
        ref="editInfoForm"
        :rules="rules"
        :model="editInfoForm"
        label-width="130px"
      >
        <el-form-item label="金主昵称" prop="name">
          <el-input class="inpt_size" v-model="editInfoForm.name"></el-input>
        </el-form-item>
        <el-form-item label="金主QQ" prop="qq_account">
          <el-input
            class="inpt_size"
            v-model="editInfoForm.qq_account"
          ></el-input>
        </el-form-item>
        <el-form-item label="金主微信" prop="wx_account">
          <el-input
            class="inpt_size"
            v-model="editInfoForm.wx_account"
          ></el-input>
        </el-form-item>
        <el-form-item label="金主电话号码" prop="mobile">
          <el-input class="inpt_size" v-model="editInfoForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="添加标签" prop="connectionlabel_ids">
          <el-checkbox-group
            v-model="editInfoForm.connectionlabel_ids"
            @change="selectLabel"
          >
            <el-checkbox
              v-for="item in labeList"
              :key="item.id"
              :label="item.id"
              :value="item.id"
              >{{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="批注">
          <el-input
            class="inpt_size"
            v-model="editInfoForm.connectionremark"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="info_btn"
            type="primary"
            round
            @click="onSubmiOwnerDwmand"
            >确认修改</el-button
          >
          <el-button class="info_btn" type="info" plain round @click="goBack"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { label_list, edit_connection } from "@/utils/owner";
export default {
  data() {
    return {
      editdata: "", //参数对象
      editInfoForm: {
        departmentuser_id: "", //所属金主部id
        name: "", //金主昵称
        qq_account: "", //金主QQ
        wx_account: "", //金主微信
        mobile: "", //金主电话号码
        connectionlabel_ids: [], //标签
        connectionremark: "", //批注
        connection_id: "", //金主id
        connection_expand_id: "", //金主扩展id-金主列表获取
        connectionlabel_text:""//金主扩展文本-金主列表获取
      },
      rules: {
        name: { required: true, trigger: "blur", message: "金主昵称不能为空" },
        qq_account: [
          {
            required: true,
            trigger: "blur",
            message: "金主QQ不能为空"
          },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "QQ格式不正确" }
        ],
        connectionlabel_ids: {
          required: true,
          trigger: "blur",
          message: "标签不能为空"
        }
      },
      labeList: [], //标签的数据
      selectLabelList: [], //选中标签的数据
      filterData: "", //筛选数据
      active: "" //当前选项卡的值
    };
  },
  created() {
    this.editdata = JSON.parse(this.$route.query.data);
    this.active = JSON.parse(this.$route.query.active);
    this.filterData = JSON.parse(this.$route.query.filter);
    console.log("修改金主", this.filterData);
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getData();
    this.getOwnerLabel();
  },
  methods: {
    // 获取数据
    getData() {
      var that = this;
      that.editInfoForm.departmentuser_id = this.ownerId;
      that.editInfoForm.name = this.editdata.name;
      that.editInfoForm.qq_account = this.editdata.qq_account;
      that.editInfoForm.wx_account = this.editdata.wx_account;
      that.editInfoForm.mobile = this.editdata.mobile;
      that.editInfoForm.connectionremark = this.editdata.connectionremark_text;
      that.editInfoForm.connection_id = this.editdata.id;
      that.editInfoForm.connection_expand_id = this.editdata.connection_expand_id;
      that.editInfoForm.connectionlabel_text = this.editdata.connectionlabel_text;
      
      if (this.editdata.connectionlabel_ids) {
        var str = this.editdata.connectionlabel_ids;
        var select_arr = str.split(",");
        that.editInfoForm.connectionlabel_ids = select_arr.map(Number);
      }
    },
    // 获取金主标签
    getOwnerLabel() {
      var that = this;
      label_list().then(res => {
        if (res.data.code == 1) {
          that.labeList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 选中标签的值
    selectLabel(val) {
      var that = this;
      that.selectLabelList = val;
    },
    // 表单提交
    onSubmiOwnerDwmand() {
      var that = this;
      that.editInfoForm.departmentuser_id = that.ownerId;
      var arr = that.editInfoForm.connectionlabel_ids;
      var str = arr.join(",");
      that.editInfoForm.connectionlabel_ids = str;
      let obj = {
        ...that.editInfoForm
      };
      //修改金主信息
      edit_connection(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          this.$route.params.filter = this.filterData;
          this.$route.params.active = this.active;
          this.$router.push({ path: "/myOwner" });
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    //   取消返回首页
    goBack() {
      var that = this;
      // this.$route.params.filter = this.filterData;
      this.$route.params.filter = this.filterData;
      this.$route.params.active = this.active;
      this.$route.params.edit_id = 1;
      this.$router.push({ path: "/myOwner" });

      // this.$router.back();
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.demand_box {
  background-color: #ffffff;
  height: 100%;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.owner_box {
  padding: 45px 30px;
}
.owner_box .el-form-item__label {
  width: 135px !important;
}
.el-main {
  padding: 0;
}
.inpt_size {
  width: 200px;
}
.upload_size {
  width: 230px;
}
.upload_icon {
  font-size: 15px;
  margin-right: 5px;
}
.info_btn {
  width: 200px;
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerEdit.vue